import {gql} from "@irati/utils/gql"

import Recognition from "../fragments/Recognition"

const mutation = gql`
  mutation UpdateRecognitionWithRewardId($recognitionId: String!, $orderId: String!) {
    updateRecognitionWithRewardId(recognitionId: $recognitionId, orderId: $orderId) {
      ...recognitionFields
    }
  }
  ${Recognition}
`

export default mutation
